<template>
  <div>
    <router-view v-show='this.$route.matched.length==3'></router-view>
    <page-header-layout v-show='this.$route.matched.length==2'>
      <div class='main-page-content'>
        <div class='trade-page'>
          <!-- 顶部工具栏：标题说明 + 导入 + 筛选条件 -->
          <div class='trade-toolbar'>
            <div class='trade-toolbar__head'>
              <div class='trade-toolbar__heading'>
                <span class='trade-toolbar__title'>平台数据：订单导入记录</span>
                <span class='trade-toolbar__desc'>按月份、平台筛选导入批次，查看导入进度与红人匹配情况</span>
              </div>
              <el-button size='small' type='warning' icon='el-icon-upload' @click='handleImport'>导入</el-button>
            </div>
            <el-form class='trade-filter' size='small' inline :model='searchCondition' @submit.native.prevent>
              <el-form-item label='月份'>
                <el-date-picker
                  v-model='searchCondition.month'
                  class='trade-filter__control trade-filter__control--month'
                  type='month'
                  value-format='yyyy-MM-dd'
                  format='yyyy年MM月'
                  placeholder='选择月'>
                </el-date-picker>
              </el-form-item>
              <el-form-item label='平台'>
                <el-select v-model='searchCondition.platform_code'
                           class='trade-filter__control trade-filter__control--platform'
                           placeholder='可选平台' multiple collapse-tags
                           clearable>
                  <el-option v-for='(item,key) in options'
                             :label='item.label' :value='item.value'
                             :key='key'>
                    {{ item.label }}<span> ({{ item.count || 0 }})</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label='导入状态'>
                <el-select v-model='searchCondition.state' class='trade-filter__control'
                           placeholder='全部状态' clearable>
                  <el-option v-for='(label,val) in stateMap' :key='`state_${val}`' :value='val' :label='label'>
                    {{ label }}
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label='归属方式'>
                <el-select v-model='searchCondition.month_type' class='trade-filter__control'
                           placeholder='全部方式' clearable>
                  <el-option v-for='(item,val) in MonthTypes' :key='`month_type_${val}`' :value='val'
                             :label='item.label'>
                    {{ item.label }}
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class='trade-filter__actions'>
                <el-button type='primary' icon='el-icon-search'
                           :loading='loadingStatus' :disabled='loadingStatus'
                           @click.native.stop='handleQuery'>查询
                </el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class='default-table trade-table' v-loading='loadingStatus'
               element-loading-text='加载中……'
               element-loading-spinner='el-icon-loading'>
            <el-table :data='dataList' border row-key='id' empty-text='暂无导入记录'>
              <el-table-column label='序号' type='index' align='center' width='58'></el-table-column>
              <el-table-column label='归属月份' prop='month' align='center' width='112'>
                <template v-slot="{row:{month,month_type:t}}">
                  <div class='trade-month'>{{ month|parseTime('{y}年{m}月') }}</div>
                  <span title="归属方式" v-if="MonthTypes[t]" class='trade-month__type' :style="{color:MonthTypes[t].color}">
                    {{ MonthTypes[t].label }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label='归属平台' prop='platform_name' align='center' width='120'>
                <template slot-scope='{row}'>
                  <span class='trade-platform' :title='row.platform_name'>{{ row.platform_name || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column label='文件名称' prop='file_name' min-width='240' header-align='center'
                               align='left'>
                <template slot-scope='{row}'>
                  <el-link class='trade-file__name' type='primary' :underline='false'
                           icon='el-icon-document' :title='row.file_name'
                           @click='handleShowExcel(row)'>{{ row.file_name }}
                  </el-link>
                  <div class='remark' :title='row.remark'>{{ row.remark || '--' }}</div>
                </template>
              </el-table-column>
              <el-table-column label='状态' prop='state' align='center' width='100'>
                <template slot-scope='{row}'>
                  <span class='trade-state' :class='`state_${row.state}`'>
                    <i class='trade-state__dot'></i>{{ handleMap(row.state) }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column label='进度' prop='state' align='left' header-align='center' width='220'>
                <template slot-scope='{row}'>
                  <div class='trade-metrics'>
                    <div class='trade-metrics__item'>
                      <span class='trade-metrics__label'>已导入</span>
                      <span class='trade-metrics__value'>{{ $utils.numberFormat(row.row_offset) }}<em>行</em></span>
                    </div>
                    <div class='trade-metrics__item'>
                      <span class='trade-metrics__label'>表格行</span>
                      <span class='trade-metrics__value'>{{ $utils.numberFormat(row.row_count) }}<em>行</em></span>
                    </div>
                    <div class='trade-metrics__item'>
                      <span class='trade-metrics__label'>已匹配</span>
                      <span class='trade-metrics__value'>{{ $utils.numberFormat(row.matched_num) }}<em>行</em></span>
                    </div>
                    <div class='trade-metrics__item'>
                      <span class='trade-metrics__label'>匹配率</span>
                      <span class='trade-metrics__value'>{{ $utils.numberFormat(matchRate(row), 2) }}<em>%</em></span>
                    </div>
                  </div>
                  <div class='trade-rate'>
                    <el-progress :percentage='matchRate(row)' :stroke-width='4'
                                 color='#ff3176' :show-text='false'></el-progress>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label='耗时' prop='used_time' align='left' header-align='center' width='200'>
                <template slot-scope='{row}'>
                  <div class='trade-time-list'>
                    <div class='trade-time-list__row'>
                      <span class='trade-time-list__label'>导入</span>
                      <span>{{ secondsToReadable(row.used_time / 1000) }}</span>
                    </div>
                    <div class='trade-time-list__row'>
                      <span class='trade-time-list__label'>匹配</span>
                      <span>{{ secondsToReadable(row.matched_time / 1000) }}</span>
                    </div>
                    <div class='trade-time-list__row'>
                      <span class='trade-time-list__label'>效率</span>
                      <span>每秒 {{ row.used_time > 0 ? $utils.numberFormat(1000 * row.row_offset / row.used_time, 2) : '-' }} 行</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label='时间信息' align='left' header-align='center' width='186'>
                <template slot-scope='{row}'>
                  <div class='trade-time-list'>
                    <div class='trade-time-list__row'>
                      <span class='trade-time-list__label'>创建</span>
                      <span>{{ row.created_at }}</span>
                    </div>
                    <div class='trade-time-list__row'>
                      <span class='trade-time-list__label'>更新</span>
                      <span>{{ row.updated_at }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label='操作' align='center' width='168' fixed='right'>
                <template slot-scope='{row}'>
                  <div v-if='[1].indexOf(row.state)>-1' class='trade-ops__loading'>
                    <i class='el-icon-loading'></i><span>载入中，请稍后…</span>
                  </div>
                  <div v-else class='trade-ops'>
                    <el-link type='primary' :underline='false' icon='el-icon-view'
                             @click.native.stop='handleViewDetail(row)'>查看详情
                    </el-link>
                    <el-dropdown trigger='click' @command='(e,a)=>handleCommand(row,e,a)'>
                      <span class='trade-ops__more'>
                        更多<i class='el-icon-arrow-down el-icon--right'></i>
                      </span>
                      <el-dropdown-menu slot='dropdown'>
                        <el-dropdown-item icon='el-icon-refresh-left' command='cancel'>
                          撤回
                        </el-dropdown-item>
                        <el-dropdown-item icon='el-icon-coin' command='store'>
                          载入
                        </el-dropdown-item>
                        <el-dropdown-item icon='el-icon-paperclip' command='match'>
                          匹配
                        </el-dropdown-item>
                        <el-dropdown-item icon='el-icon-delete' command='delete'>
                          删除
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class='trade-pagination'>
              <m-pagination v-show='total>0' :total.sync='total' :limit.sync='pagingData.page_size'
                            :page.sync='pagingData.current_page'
                            @pagination='getList'></m-pagination>
            </div>
          </div>
        </div>
      </div>
    </page-header-layout>

    <!--    导入Excel文件并保存-->
    <el-dialog :visible.sync='open'>
      <div>
        <ImportAndCreate ref='refImportAndCreate' @close='open=false' @saved='handleQuery'></ImportAndCreate>
      </div>
    </el-dialog>

    <!--    表格数据预览-->
    <el-dialog :visible.sync='fileOpen' fullscreen>
      <div style='padding: 5px'>
        <ExcelPageTable :key='`ExcelPageTable_${currentRow.id}`' :file-info='currentRow'
                        ref='refPreviewExcelPageTable' />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TradeImport from '@/pages/trade/import/TradeImport'
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import MlPageTable from '@/components/common/MlPageTable'
import PlatformSelect from '@/pages/lb/components/PlatformSelect'
import ImportAndCreate from '@/pages/trade/import/ImportAndCreate'
import {
  cancelTradeImported,
  deleteTradeImported,
  getTradeImportList, matchTradeImported,
  optionsTradeImported,
  storeTradeImported
} from '@/api/trade_import'
import ExcelPageTable from '@/pages/trade/import/ExcelPageTable'
import { MonthTypes } from './trade'

export default {
  name: 'TradeIndex',
  components: { ExcelPageTable, ImportAndCreate, PlatformSelect, MlPageTable, PageHeaderLayout, TradeImport },
  data() {
    return {
      MonthTypes,
      loadingCommit: false,
      loadingStatus: false,
      open: false,
      fileOpen: false,
      currentRow: { id: null, name: null },
      searchCondition: { month: null, platform_code: [], state: null },
      options: {},
      pagingData: { page_size: 10, current_page: 1 },
      total: 0,
      tableName: 'trade_import_list',
      dataList: [],
      columns: [
        { hide: false, prop: 'tid', label: '订单ID', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'goods_id', label: '商品ID', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'goods_title', label: '商品名称', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'pay_at', label: '付款时间', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'kol_nickname', label: '达人昵称', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'kol_id', label: '达人抖音号', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'trade_status', label: '订单状态', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'trade_source', label: '下单来源', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'flow_source', label: '流量来源', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'flow_sub', label: '流量细分渠道', width: 100, sortable: false, fixed: false },
        { hide: false, prop: 'file_md5', label: '导入文件md5', width: 100, sortable: false, fixed: false }
      ],
      stateMap: {}
      // 订单id	商品id	商品名称	订单状态	流量来源	超时未结算原因

    }
  },
  created() {
    this.init()
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.matched': function(n, o) {
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      // console.log(this.$route.matched.length === 2)
      //避免详情路由页面打开时候加载父页面的网络请求
      if (this.$route.matched.length === 2) {
        this.loadOptions()
        this.handleQuery()
      }
    },
    handleMap(state) {
      return this.stateMap[state] || state
    },
    handleImport() {
      this.open = true
      // this.$router.push({ name: 'trade-import' })
      this.$nextTick(() => {
        this.$refs['refImportAndCreate'].reset()
      })
    },
    jumpToTradeList() {
      // this.$router.push({ name: 'trade-import' })

      const { href } = this.$router.resolve({
        name: 'trade-list'
      })
      window.open(href, '_blank')
    },
    // 查看当前导入记录的订单详情：打开订单列表页并携带导入ID
    handleViewDetail(row) {
      const { href } = this.$router.resolve({
        name: 'trade-list',
        query: { import_id: row.id,month_type:row.month_type }
      })
      window.open(href, '_blank')
    },
    historyImport() {
      // this.$router.push({ name: 'trade-import' })

      const { href } = this.$router.resolve({
        name: 'trade-import'
      })
      window.open(href, '_blank')
    },
    handleQuery() {
      this.pagingData.current_page = 1
      this.getList()
    },
    handleSearchCondition() {
      const cond = {}
      Object.keys(this.searchCondition).forEach((k) => {
        if (this.searchCondition[k] !== null && this.searchCondition[k] !== '') {
          cond[k] = this.searchCondition[k]
        }
      })

      return cond
    },
    async getList() {
      this.loadingStatus = true
      const param = this.handleSearchCondition()
      Object.assign(param, this.pagingData)
      const { list, page_info, state_map } = await getTradeImportList(param)
      this.dataList = list || []
      this.pagingData.current_page = page_info.current_page || 1
      this.pagingData.page_size = page_info.page_size || 10
      this.total = page_info.total || 0
      this.loadingStatus = false
      this.stateMap = state_map || {}
    },
    async handleCancel(row) {
      if (this.loadingCommit) {
        return false
      }
      this.$confirm('确认要撤回导入的数据？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loadingCommit = true
        const data = await cancelTradeImported(row.id)
        if (data) {
          await this.getList()
          this.$notify.success('已撤回')
        }
        this.loadingCommit = false
      }).catch(() => {
        this.loadingCommit = false
        this.$message({
          type: 'info',
          message: '已取消撤回'
        })
      })

    },
    async loadOptions() {
      // 加载可选平台，即系统里已录入的平台
      const { platform } = await optionsTradeImported()
      this.options = platform || []
    },
    handleShowExcel(row) {
      this.currentRow = { id: row.file_id, name: row.file_name }
      this.fileOpen = true
      this.$nextTick(() => {
        this.$refs['refPreviewExcelPageTable'].init()
      })

    },
    async handleMatch(row) {
      if (this.loadingCommit) {
        return false
      }
      this.$confirm('确认要执行【匹配系统红人】操作，可重复执行？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loadingCommit = true
        const data = await matchTradeImported(row.id)
        if (data) {
          this.$notify.success('已发起红人匹配，请注意匹配进度')
          setTimeout(async () => {
            this.loadingCommit = false
            await this.getList()
          }, 1000)
        }

      }).catch(() => {
        this.loadingCommit = false
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    async handleStore(row) {
      if (this.loadingCommit) {
        return false
      }
      this.$confirm('确认要二次载入表格的数据？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loadingCommit = true
        const data = await storeTradeImported(row.id)
        if (data) {
          this.$notify.success('已发起载入请求,可刷新列查看载入进度')
          setTimeout(async () => {
            this.loadingCommit = false
            await this.getList()
          }, 100)
        }

      }).catch(() => {
        this.loadingCommit = false
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确认要删除导入的表格？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loadingCommit = true
        const data = await deleteTradeImported(row.id)
        if (data) {
          await this.getList()
          this.$notify.success('已删除')
        }
        this.loadingCommit = false
      }).catch(() => {
        this.loadingCommit = false
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 匹配率（0-100，保留两位小数）
    matchRate(row) {
      const total = Number(row.row_count) || 0
      if (total <= 0) {
        return 0
      }
      const rate = Number(row.matched_num) * 100 / total
      return Math.min(100, Math.max(0, Math.round(rate * 100) / 100))
    },
    //秒数可读性
    secondsToReadable(seconds) {
      const days = Math.floor(seconds / (3600 * 24))
      const hours = Math.floor((seconds % (3600 * 24)) / 3600)
      const minutes = Math.floor((seconds % 3600) / 60)
      const secs = (seconds % 60).toFixed(3)

      const parts = []
      if (days) parts.push(`${days} 天`)
      if (hours) parts.push(`${hours} 小时`)
      if (minutes) parts.push(`${minutes} 分钟`)
      if (secs || parts.length === 0) parts.push(`${secs} 秒`)

      return parts.join('  ')
    },
    //操作指令
    handleCommand(row, command) {
      switch (command) {
        case 'cancel':
          this.handleCancel(row)
          break
        case 'store':
          this.handleStore(row)
          break
        case 'match':
          this.handleMatch(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
      // this.$message('click on item ' + command)
    }
  }
}
</script>

<style scoped>
/* 覆盖 BasicLayout 给 .main-page-content 直接子元素注入的白底与内边距，由页面自行控制留白 */
.main-page-content .trade-page {
  padding: 12px 16px 16px;
  background: transparent;
  box-sizing: border-box;
}

.trade-page {
  min-height: 100%;
}

/* ===== 顶部工具栏 ===== */
.trade-toolbar {
  position: sticky;
  top: 0;
  z-index: 10;
  margin: -12px -16px 12px;
  padding: 12px 16px 0;
  background: #fff;
  border-bottom: 1px solid #f0f2f5;
}

.trade-toolbar__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.trade-toolbar__heading {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 12px;
  min-width: 0;
}

.trade-toolbar__title {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #303133;
}

.trade-toolbar__desc {
  font-size: 12px;
  line-height: 20px;
  color: #909399;
}

.trade-filter {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.trade-filter .el-form-item {
  margin-right: 16px;
  margin-bottom: 10px;
}

.trade-filter ::v-deep .el-form-item__label {
  font-weight: 400;
  color: #606266;
}

.trade-filter .el-form-item .trade-filter__control {
  width: 150px;
}

.trade-filter .el-form-item .trade-filter__control--month {
  width: 140px;
}

.trade-filter .el-form-item .trade-filter__control--platform {
  width: 320px;
}

.trade-filter__actions {
  margin-right: 0 !important;
}

/* ===== 表格 ===== */
.trade-table {
  padding-bottom: 4px;
}

.trade-table ::v-deep .el-table td {
  vertical-align: middle;
}

.trade-table ::v-deep .el-table .cell {
  padding: 0 10px;
}

.trade-table ::v-deep .el-table__fixed-right .cell {
  padding: 0 6px;
}

.trade-month {
  font-weight: 500;
  color: #303133;
}

.trade-month__type {
  display: inline-block;
  margin-top: 2px;
  padding: 0 6px;
  border: 1px solid currentColor;
  border-radius: 9px;
  font-size: 11px;
  line-height: 16px;
}

.trade-platform {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
}

.trade-file__name {
  font-size: 13px;
  font-weight: 500;
}

.trade-file__name ::v-deep .el-link--inner {
  display: inline-flex;
  align-items: center;
}

.remark {
  margin-top: 2px;
  padding-left: 0;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #909399;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 状态胶囊 */
.trade-state {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 8px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: 12px;
  line-height: 18px;
  white-space: nowrap;
}

.trade-state__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.state_-1 {
  color: #E6A23C;
  background: #fdf6ec;
  border-color: #f5dab1;
}

.state_-2 {
  color: #F56C6C;
  background: #fef0f0;
  border-color: #fbc4c4;
}

.state_1 {
  color: #409EFF;
  background: #ecf5ff;
  border-color: #b3d8ff;
}

.state_2 {
  color: #67C23A;
  background: #f0f9eb;
  border-color: #c2e7b0;
}

/* 进度指标 */
.trade-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 10px;
}

.trade-metrics__item {
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
  white-space: nowrap;
}

.trade-metrics__label {
  flex: none;
  font-size: 12px;
  color: #909399;
}

.trade-metrics__value {
  font-weight: 500;
  color: #303133;
  font-variant-numeric: tabular-nums;
}

.trade-metrics__value em {
  margin-left: 1px;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  color: #909399;
}

.trade-rate {
  margin-top: 6px;
  padding-right: 2px;
}

.trade-rate ::v-deep .el-progress-bar {
  padding-right: 0;
  margin-right: 0;
}

.trade-rate ::v-deep .el-progress-bar__outer {
  background-color: #f2f3f5;
}

.trade-rate ::v-deep .el-progress-bar__inner {
  border-radius: 2px;
}

/* 耗时 / 时间信息 */
.trade-time-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  color: #606266;
  font-variant-numeric: tabular-nums;
}

.trade-time-list__row {
  display: flex;
  gap: 6px;
  white-space: nowrap;
}

.trade-time-list__label {
  flex: none;
  min-width: 28px;
  color: #909399;
}

/* 操作列 */
.trade-ops {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 10px;
}

.trade-ops ::v-deep .el-link {
  font-size: 12px;
}

.trade-ops__more {
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  color: #606266;
  cursor: pointer;
  transition: color 0.2s;
}

.trade-ops__more:hover {
  color: #ff3176;
}

.trade-ops__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  line-height: 20px;
  color: #ff4949;
}

/* 分页 */
.trade-pagination {
  display: flex;
  justify-content: flex-end;
  padding: 10px 4px 2px;
}

/* 窄屏适配 */
@media (max-width: 1360px) {
  .trade-filter .el-form-item .trade-filter__control--platform {
    width: 240px;
  }
}
</style>
